/**
 * Three-column popup listing every step type. Used at the pipeline root and
 * inside each loop body — the consumer wires `onPick` to its own
 * `addTransformStep(type, target)` call.
 */
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TransformStepType } from "stores/queryBuilderStore"
import {
  STEP_GROUPS,
  STEP_TYPE_DESCRIPTIONS,
  STEP_TYPE_ICONS,
  STEP_TYPE_LABELS,
} from "./stepTypeConfig"

interface StepMenuProps {
  onPick: (type: TransformStepType) => void
}

const StepMenu: React.FC<StepMenuProps> = ({ onPick }) => (
  <div className="qc-step-menu" role="menu">
    {STEP_GROUPS.map((group) => (
      <div key={group.label} className="qc-step-menu__column">
        <div className="qc-step-menu__column-title">{group.label}</div>
        {group.steps.map((type) => (
          <button
            key={type}
            type="button"
            role="menuitem"
            className="qc-step-menu__option"
            onClick={() => onPick(type)}
          >
            <FontAwesomeIcon
              icon={STEP_TYPE_ICONS[type]}
              className="qc-step-menu__icon"
            />
            <div className="qc-step-menu__text">
              <div className="qc-step-menu__title">
                {STEP_TYPE_LABELS[type]}
              </div>
              <div className="qc-step-menu__desc">
                {STEP_TYPE_DESCRIPTIONS[type]}
              </div>
            </div>
          </button>
        ))}
      </div>
    ))}
  </div>
)

export default StepMenu
